module.exports = __webpack_public_path__ + "static/img/default.885df069.png";